exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-inner[data-v-ecc7f904]{padding:2.2rem 0 2.3rem;border-bottom:.1rem solid var(--border-color);position:relative}.header-inner .header-top-menu[data-v-ecc7f904]{position:absolute;right:0;z-index:5;display:inline-flex;align-items:center;font-weight:500}.header-inner .header-top-menu .devider[data-v-ecc7f904]{margin:0 10px}.header-inner .header-top-menu i[data-v-ecc7f904]{padding-right:6px}@media (max-width:767px){.header-inner[data-v-ecc7f904]{display:flex;flex-direction:column}.header-inner .header-top-menu[data-v-ecc7f904]{margin-top:10px;position:static}}", ""]);

// exports
